const features = {
    namespaced: true,
    state: () => ({
        selectedFeatures: []
    }),
    mutations: {
        SET_SELECTED_FEATURES(state, features) {
            state.selectedFeatures = features;
        },
        TOGGLE_FEATURE(state, feature) {
            const isSelected = state.selectedFeatures.includes(feature);
            if (isSelected) {
                state.selectedFeatures = state.selectedFeatures.filter(f => f !== feature);
            }
            else {
                state.selectedFeatures = [...state.selectedFeatures, feature];
            }
        },
        CLEAR_FEATURES(state) {
            state.selectedFeatures = [];
        }
    },
    actions: {
        setSelectedFeatures({ commit }, features) {
            commit('SET_SELECTED_FEATURES', features);
        },
        toggleFeature({ commit }, feature) {
            commit('TOGGLE_FEATURE', feature);
        },
        clearFeatures({ commit }) {
            commit('CLEAR_FEATURES');
        },
        loadFromStorage({ commit }) {
            if (typeof localStorage === 'undefined')
                return;
            const value = localStorage.getItem('features-store');
            if (value) {
                try {
                    const parsed = JSON.parse(value);
                    if (parsed.state && Array.isArray(parsed.state.selectedFeatures)) {
                        commit('SET_SELECTED_FEATURES', parsed.state.selectedFeatures);
                    }
                }
                catch (error) {
                    console.error('Erreur lors du chargement des features depuis le stockage local:', error);
                }
            }
        }
    },
    getters: {
        selectedFeatures: (state) => state.selectedFeatures,
        isFeatureSelected: (state) => (feature) => state.selectedFeatures.includes(feature)
    }
};
export default features;
